export const EXPERIMENTS = {
  FLOW_POP_VS_PAGE: 'NdcLyjROTq6JoL_Z7M4K3A',
}

export const VARIANTS = {
  Original: '0',
  Variant1: '1',
  Variant2: '2',
  Variant3: '3',
}

class GoogleOptimizeService {
  getVariant(experimentId) {
    if (window.google_optimize) {
      let variant = window.google_optimize.get(experimentId)
      if (variant == undefined) return VARIANTS.Original
      else return variant
    } else return VARIANTS.Original
  }

  isOriginal(experimentId) {
    return this.getVariant(experimentId) == VARIANTS.Original
  }

  isVariant1(experimentId) {
    return this.getVariant(experimentId) == VARIANTS.Variant1
  }
}

export default new GoogleOptimizeService()
